import React from 'react'
import ModalFormContrForn from '../../../components/Modals/ModalFormContrForn/ModalFormContrForn'

const BudgetCreateContratoModal = ({
  isOpen,
  onClose,
  orcItemId,
  onSuccess,
}) => {
  if (!orcItemId) return null

  return (
    <ModalFormContrForn
      isOpen={isOpen}
      onClose={onClose}
      hideTrigger
      pedidoCompraData={{ orcItem_id: Number(orcItemId) }}
      orcItemDisabled
      centroDeCustoDisabled
      onSuccess={() => {
        onSuccess?.()
        onClose?.()
      }}
    />
  )
}

export default BudgetCreateContratoModal
